import { render, staticRenderFns } from "./meetingPage.vue?vue&type=template&id=2195ed1b&"
import script from "./meetingPage.vue?vue&type=script&lang=js&"
export * from "./meetingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports